import { invitesTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: false,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case invitesTypes.GET_INVITES_FOR_PHARM__REQUEST: return {
      ...state,
      isRequesting: true
    }
    case invitesTypes.GET_INVITES_FOR_PHARM__SUCCESS: return {
      ...state,
      isRequesting: false,
      items: action.payload.items
    }
    default:
      return state
  }
}
